

















import Vue from 'vue'

import {
  validateMinDate,
  validateMaxDate
} from './helpers/validateHelpers'
export default Vue.extend({
  name: 'FreeFieldDate',
  props: {
    field: {
      type: Object,
      required: true
    },
    slideId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      dateValue: this.field.value ? this.field.value : undefined,
      validated: true
    }
  },
  computed: {
    fieldDOMId(): string {
      return `${this.$store.state.clickFlowID}-date-${this.field.id}`
    },
    validateError(): string {
      return !this.validated ? 'cfa-free-field-date-validate-error' : ''
    },
    optionResult(): IDate & {
      reply: string
    } {
      return this.$store.getters.getOptionsResultByFieldIdAndSlideId(
        this.field.id,
        this.slideId
      )
    }
  },
  methods: {
    updateValue() {
      if (
        validateMinDate(this.optionResult, this.dateValue) &&
        validateMaxDate(this.optionResult, this.dateValue)
      ) {
        this.validated = true
        this.$store.commit('updateValue', {
          slideId: this.slideId,
          field: this.field,
          fieldValue: this.dateValue
        })
      } else {
        this.validated = false
        this.$store.commit('updateValue', {
          slideId: this.slideId,
          field: this.field,
          fieldValue: ''
        })
      }
    }
  }
})
